import { useState } from 'react';

import { MockLuminaire } from '../../../types/analytics';

interface LampThumbProps {
  luminaire: MockLuminaire;
  size?: number;
}

/**
 * Square thumbnail that renders the luminaire's product photo and falls back to
 * a coloured gradient with the series initials when no image is available.
 */
export const LampThumb = ({ luminaire, size = 40 }: LampThumbProps) => {
  const [failed, setFailed] = useState(false);
  const dim = `${size}px`;
  const initials = luminaire.series
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  if (failed || !luminaire.imageUrl) {
    return (
      <div
        className="rounded-md flex-shrink-0 flex items-center justify-center text-[10px] font-bold text-white/85"
        style={{
          width: dim,
          height: dim,
          background: `linear-gradient(135deg, ${luminaire.thumbnailColor}cc, ${luminaire.thumbnailColor}55)`,
        }}
        title={luminaire.series}
      >
        {initials}
      </div>
    );
  }

  return (
    <div
      className="rounded-md flex-shrink-0 overflow-hidden bg-greyP5 border border-greyP4"
      style={{ width: dim, height: dim }}
      title={luminaire.series}
    >
      <img
        src={luminaire.imageUrl}
        alt={`${luminaire.series} luminaire`}
        loading="lazy"
        onError={() => setFailed(true)}
        className="w-full h-full object-contain"
        style={{ background: 'white' }}
      />
    </div>
  );
};
